import { Component, OnInit, Input, ViewChild, ElementRef, NgZone } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader, MouseEvent } from '@agm/core';

declare const google: any;

@Component({
  selector: 'app-map-marker-dialog',
  templateUrl: './map-marker-dialog.component.html',
  styleUrls: ['./map-marker-dialog.component.css']
})
export class MapMarkerDialogComponent implements OnInit {
  @Input()
  latitude: number;
  @Input()
  longitude: number;

  // latitude: number;
  // longitude: number;
  selectedLatitude: number;
  selectedLongitude: number;
  zoom: number;
  address: string;
  private geoCoder;

  @ViewChild('search')
  public searchElementRef: ElementRef;

  constructor(
    public activeModal: NgbActiveModal,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.mapsAPILoader.load().then(() => {
      if (this.latitude && this.longitude) {
        this.selectedLatitude = this.latitude;
        this.selectedLongitude = this.longitude;
        this.zoom = 12;
      } else {
        this.setCurrentLocation();
      }

      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          // let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          let place = autocomplete.getPlace();

          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.selectedLatitude = place.geometry.location.lat();
          this.selectedLongitude = place.geometry.location.lng();
          this.zoom = 12;

        });
      });

      this.getAddress(this.latitude, this.longitude);
    });
  }

  private setCurrentLocation() {
    this.latitude = -6.212985210827575;
    this.longitude = 106.84255795625002;
    this.selectedLatitude = -6.212985210827575;
    this.selectedLongitude = 106.84255795625002;
    this.zoom = 12;
    // if ('geolocation' in navigator) {
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     this.latitude = position.coords.latitude;
    //     this.longitude = position.coords.longitude;
    //     this.selectedLatitude = position.coords.latitude;
    //     this.selectedLongitude = position.coords.longitude;
    //     this.zoom = 12
    //     this.getAddress(this.latitude, this.longitude);
    //   });
    // }
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
        }
      }
    });
  }

  onMapMarked($event: MouseEvent) {
    this.selectedLatitude = $event.coords.lat;
    this.selectedLongitude = $event.coords.lng;
    this.getAddress($event.coords.lat, $event.coords.lng);
  }

  onMapClicked($event: MouseEvent) {
    this.selectedLatitude = $event.coords.lat;
    this.selectedLongitude = $event.coords.lng;
    this.getAddress($event.coords.lat, $event.coords.lng);
  }

}
